import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Layout, notification, Select } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined, ShopOutlined } from "@ant-design/icons";
import ExampleService from "../../services/ExampleService";
import Logo from "./Logo";
import NavLanguage from "./NavLanguage";
import NavProfile from "./NavProfile";
import NavPanel from "./NavPanel";
import NavSearch from "./NavSearch";
import { toggleCollapsedNav, onMobileNavToggle } from "redux/actions/Theme";
import {
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from "constants/ThemeConstant";
import utils from "utils";
import NavTitle from "./NavTitle";

const { Header } = Layout;
const { Option } = Select;

export const HeaderNav = (props) => {
  const {
    navCollapsed,
    mobileNav,
    navType,
    headerNavColor,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
    currentTheme,
    direction,
  } = props;
  const [searchActive, setSearchActive] = useState(false);

  const onSearchClose = () => {
    setSearchActive(false);
  };

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userinfo"));
    if (userInfo?.userType != "1") {
      if (!isMobile) toggleCollapsedNav(true);
      else onMobileNavToggle(true);
    }
  }, []);

  const onToggle = () => {
    if (!isMobile) toggleCollapsedNav(!navCollapsed);
    else onMobileNavToggle(!mobileNav);
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(
        currentTheme === "dark" ? "#00000" : "#ffffff"
      );
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return "0px";
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  useEffect(() => {
    if (!isMobile) {
      onSearchClose();
    }
  }, []);
  const [selectedStore, setSelectedStore] = useState(null);
  const [userInfoState, setUserInfoState] = useState(null);
  const [storeChanging, setStoreChanging] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userinfo"));
    setUserInfoState(user);
    setSelectedStore(user?.storeId || null);
  }, []);

  const handleStoreChange = (storeId) => {
    if (storeId === selectedStore) return;

    setStoreChanging(true);
    ExampleService.setEdit(`User/changeStore/${storeId}`, {})
      .then((resp) => {
        if (resp?.status === 1) {
          setSelectedStore(storeId);
          ExampleService.getPost("auth/userinfo", null)
            .then((resp) => {
              localStorage.setItem("authority", new Set(resp?.data?.user?.role?.actions));
              localStorage.setItem("userinfo", JSON.stringify(resp?.data?.user));
              localStorage.setItem(AUTH_TOKEN, resp?.data?.accessToken)
              setUserInfoState(resp?.data?.user);
            })
            .catch((e) => {
              if (e) console.log(e);
            });

          notification.success({
            message: "Şube başarıyla değiştirildi",
            placement: "topRight",
          });

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          notification.error({
            message: resp?.errorMessage || "Şube değiştirilemedi",
            placement: "topRight",
          });
        }
      })
      .catch((e) => {
        console.error(e);
        notification.error({
          message: "Şube değiştirilemedi",
          placement: "topRight",
        });
      })
      .finally(() => {
        setStoreChanging(false);
      });
  };
  const StoreSelector = () => {
    if (!userInfoState?.userStores || userInfoState.userStores.length === 0) return null;

    return (
      <div className="d-flex align-items-center px-4 py-3 border-bottom">
        <Select
          value={selectedStore}
          onChange={handleStoreChange}
          loading={storeChanging}
          style={{ width: 100 }}
          placeholder="Şube seçiniz"
          size="middle"
          className="flex-grow-1"
        >
          {userInfoState.userStores.map((store) => (
            <Option key={store.storeId} value={store.storeId}>
              {store.store?.name}
            </Option>
          ))}
        </Select>
      </div>
    );
  };
  const userInfo = JSON.parse(localStorage.getItem("userinfo"));
  return (
    <Header
      className={`app-header ${navMode}`}
      style={{ backgroundColor: headerNavColor }}
    >
      <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
        <Logo logoType={navMode} />
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          {userInfoState?.userType == "1" && (
            <div className="nav-left">
              <ul className="ant-menu ant-menu-root ant-menu-horizontal">
                {isNavTop && !isMobile ? null : (
                  <li
                    className="ant-menu-item ant-menu-item-only-child"
                    onClick={() => {
                      onToggle();
                    }}
                  >
                    {navCollapsed || isMobile ? (
                      <MenuUnfoldOutlined className="nav-icon" />
                    ) : (
                      <MenuFoldOutlined className="nav-icon" />
                    )}
                  </li>
                )}
              </ul>
            </div>
          )}

          <div className="nav-right">
            {/* <NavLanguage /> */}
            <StoreSelector />
            <NavProfile />
            {/* <NavPanel direction={direction} /> */}
          </div>
          <NavSearch active={searchActive} close={onSearchClose} />
          <NavTitle />
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme }) => {
  const {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  } = theme;
  return {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(HeaderNav);
